// extracted by mini-css-extract-plugin
var _1 = "OvHH5F";
var _2 = "kNn53D";
var _3 = "zmXSp8";
var _4 = "FFqR94";
var _5 = "hlvUOM";
var _6 = "pQ6Y_i";
var _7 = "e8HTcD";
var _8 = "jqXbS9";
export { _1 as "ease-transition", _2 as "gradient-titanic-80", _3 as "linear-transition-05", _4 as "root", _5 as "shadow-medium-titanic", _6 as "shadow-medium-titanic-hover", _7 as "shadow-titanic-1", _8 as "shadow-white" }
